const ruleRouters = {
  path: "/rule",
  component: () => import("@/views/layout"),
  name: "rule",
  meta: { public: true, theme: "none" },
  children: [
    {
      path: "edit",
      component: () => import("@/views/Backend/Admin/Statistics/AutoCount/RuleEdit"),
      name: "rule-edit"
    }
  ]
}

export default ruleRouters
